<script lang="ts" setup>
import { IconChevronRight } from "@tabler/icons-vue";
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<li
		role="presentation"
		aria-hidden="true"
		:class="twMerge('[&>svg]:size-3.5', props.class)"
	>
		<slot>
			<IconChevronRight />
		</slot>
	</li>
</template>
